import { createRoot } from 'react-dom/client';
import { Toast } from '@/features/home/components/Toast';

/**
 * Shows a toast that stays up across route changes — mirrors Flutter
 * GenericHelpers.customAlertMsgNotifier / CustomFlushBar, which sit in the app overlay, so a
 * message shown right before navigateTo() (e.g. "password updated" → /home) is still seen.
 *
 * The toast renders in its own root at the end of <body> and removes itself when it closes.
 * Like Toast, it translates the message, so pass Flutter's untranslated text.
 */
export function showToast(
  message: string,
  type: 'success' | 'error' | 'info' = 'error',
  durationMs?: number,
): void {
  const host = document.createElement('div');
  document.body.appendChild(host);
  const root = createRoot(host);

  let closed = false;
  const close = () => {
    if (closed) return;
    closed = true;
    // Unmount after the current React work finishes
    setTimeout(() => {
      root.unmount();
      host.remove();
    }, 0);
  };

  root.render(<Toast message={message} type={type} onClose={close} duration={durationMs} />);
}
